import { render, staticRenderFns } from "./BaseSearchItem.vue?vue&type=template&id=40838098&scoped=true"
import script from "./BaseSearchItem.vue?vue&type=script&lang=js"
export * from "./BaseSearchItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40838098",
  null
  
)

export default component.exports